// Der Brieftext wird nicht gespeichert wie er dasteht: Gespeichert ist ein Rohtext, aus
// dem Betreff und Brieftext beim Zeichnen herausgeschnitten werden. Diese zwei Funktionen
// sind die einzige Stelle, an der geschnitten und wieder zusammengesetzt wird — sie
// müssen zueinander passen. Passen sie nicht, ändert sich der Brief beim Speichern von
// alleine, und genau das ist hier schon einmal passiert.

/**
 * Schneidet aus dem Rohtext den Teil heraus, der als Brieftext angezeigt und bearbeitet
 * wird. `prefix` ist das, was davor stehen bleibt (bis einschließlich Betreffzeile).
 */
export function brieftextAusRohtext(rohtext = '', betreffRohzeile = '', vollName = '') {
  const betreffIdx = betreffRohzeile ? rohtext.indexOf(betreffRohzeile) : -1;
  const prefix = betreffIdx >= 0 ? rohtext.slice(0, betreffIdx + betreffRohzeile.length) : '';
  const basis = betreffIdx >= 0
    ? rohtext.slice(betreffIdx + betreffRohzeile.length).trimStart()
    : rohtext;

  // Fehlt die Unterschrift im Rohtext, wird sie ergänzt — und zwar für Anzeige UND
  // Bearbeitungsmodus gleichermaßen. Stünde sie nur in einem der beiden Zweige,
  // verschwände der Name beim Einschalten des Stifts wieder.
  const nachname = vollName.trim().split(/\s+/).pop() || vollName;
  const zeilen = basis.trimEnd().split('\n');
  const letzteZeile = (zeilen[zeilen.length - 1] || '').trim();
  const letzteDrei = zeilen.slice(-3).join('\n');
  // Der Name gehört direkt unter den Gruß, ohne Leerzeile dazwischen. Endet der Brief
  // bereits mit dem Namen, wird eine gespeicherte Leerzeile entfernt — sonst behielten
  // ältere Briefe die Lücke für immer. Geprüft wird dafür die letzte Zeile, nicht der
  // ganze Text: sonst könnte ein im Fließtext erwähnter Name den Gruß an den Absatz
  // darüber kleben.
  const endetMitName = !!vollName && (letzteZeile === vollName || (!!nachname && letzteZeile.endsWith(nachname)));
  const rawBody = endetMitName
    ? basis.trimEnd().replace(/\n[ \t]*\n(?=[^\n]*$)/, '\n')
    : (!vollName || basis.includes(vollName) || (!!nachname && letzteDrei.includes(nachname)))
      ? basis
      : basis.trimEnd() + '\n' + vollName;

  return { rawBody, prefix };
}

/**
 * Setzt den Rohtext wieder zusammen. Die Leerzeile trennt Betreff und Brieftext — ohne
 * Betreff gibt es nichts zu trennen, und sie würde den Brief bei jedem Speichern um zwei
 * Zeilen nach unten schieben.
 */
export function rohtextMitBrieftext(prefix = '', neuerBody = '') {
  const body = neuerBody.trimStart();
  return prefix ? prefix + '\n\n' + body : body;
}
